<template>
    <b-card>
      <b-card-header class="d-flex justify-content-between align-items-center">
        <b-card-title>Quantity of Sales Over Time</b-card-title>
        <b-form inline>
          <b-form-datepicker
            v-model="startDate"
            class="mr-2"
            :max="endDate"
            placeholder="Start Date"
          ></b-form-datepicker>
          <b-form-datepicker
            v-model="endDate"
            :min="startDate"
            placeholder="End Date"
          ></b-form-datepicker>
        </b-form>
      </b-card-header>
      <apexchart
        type="line"
        :height="chartOptions.chart.height"
        :options="chartOptions"
        :series="series"
      />
    </b-card>
  </template>
  
  <script>
  import VueApexCharts from "vue-apexcharts";
  import {
    BCard,
    BCardTitle,
    BCardHeader,
    BForm,
    BFormDatepicker
  } from "bootstrap-vue";
  
  export default {
    name: "SalesQuantityChart",
    components: {
      apexchart: VueApexCharts,
      BCard,
      BCardHeader,
      BCardTitle,
      BForm,
      BFormDatepicker
    },
    props: {
      data: {
        type: Array,
        required: true,
        default: () => []
      }
    },
    data() {
      return {
        startDate: this.getDefaultStartDate(),
        endDate: new Date().toISOString().slice(0, 10),
      };
    },
    computed: {
    //   filteredData() {
    //     return this.data.filter(item => {
    //       const date = new Date(item.date);
    //       return date >= new Date(this.startDate) && 
    //              date <= new Date(this.endDate);
    //     });
    //   },
      series() {
        return [{
          name: 'Sales Quantity',
          data: this.data.map(item => ({
            x: item.period,
            y: item.salesCount
          }))
        }];
      },
      chartOptions() {
        return {
          chart: {
            height: 350,
            type: 'line',
            zoom: {
              enabled: true,
              type: 'x',
            },
            toolbar: {
              show: true,
              tools: {
                download: true,
                selection: true,
                zoom: true,
                zoomin: true,
                zoomout: true,
                pan: true,
              }
            }
          },
          stroke: {
            curve: 'smooth',
            width: 3
          },
          colors: ['#2E93fA'],
          dataLabels: {
            enabled: false
          },
          grid: {
            borderColor: '#f1f1f1',
          },
          xaxis: {
            type: 'datetime',
            title: {
              text: 'Date'
            },
            labels: {
              datetimeFormatter: {
                year: 'yyyy',
                month: 'MMM yyyy',
                day: 'dd MMM',
                hour: 'HH:mm'
              }
            }
          },
          yaxis: {
            title: {
              text: 'Quantity of Sales'
            },
            labels: {
              formatter: function(val) {
                return val.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
            }
          },
          tooltip: {
            theme: 'dark',
            x: {
              format: 'dd MMM yyyy'
            },
            y: {
              formatter: function(val) {
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " units"
              }
            }
          }
        };
      }
    },
    methods: {
      getDefaultStartDate() {
        const date = new Date();
        date.setMonth(date.getMonth() - 1);
        return date.toISOString().slice(0, 10);
      }
    }
  };
  </script>
  
  <style scoped>
  .b-form-datepicker {
    width: 200px;
  }
  
  @media (max-width: 768px) {
    .b-card-header {
      flex-direction: column;
      align-items: stretch !important;
    }
    
    .b-form {
      margin-top: 1rem;
    }
    
    .b-form-datepicker {
      width: 100%;
      margin-right: 0 !important;
      margin-bottom: 0.5rem;
    }
  }
  </style>